var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "brain",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#666",
    strokeWidth: 30,
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M142.54,223.44c-1.18,30.07,15.16,57.96,41.41,70.85c29.15,14.3,65.22,7.5,88.19-17.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.77,353.55c5.17-0.09,22.8-1.03,38.88-14.4c16.98-14.12,20.76-32.57,21.6-37.46"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M498.98,223.44c0.95,30.08-15.6,57.84-41.95,70.53c-29.26,14.08-65.27,7-88.06-17.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.74,353.41c-5.16-0.13-22.79-1.21-38.77-14.7c-16.87-14.25-20.51-32.73-21.31-37.62"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.76,395.32c-5.87-0.02-31.26,0.53-51.84,20.16c-28.34,27.04-21.85,65.77-21.29,68.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.32,560.92c0.3-5.05,1.42-32.54-19.44-55.44c-23.22-25.49-54.9-24.67-59.34-24.48"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.4,395.32c5.87-0.02,31.26,0.53,51.84,20.16c28.34,27.04,21.85,65.77,21.29,68.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.84,560.92c-0.3-5.05-1.42-32.54,19.44-55.44c23.22-25.49,54.9-24.67,59.34-24.48"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320,41.08c0,173.28,0,346.56,0,519.84c-14.11,29.87-43.21,49.97-76.12,52.56c-51.88,4.08-81.89-37.83-83.11-39.6c-8.51-3.06-33.47-13.28-51.29-40.08c-15.94-23.96-17.26-47.77-17.28-57.12c-5.05-2.64-29.82-16.25-39.36-46.56c-11.5-36.53,8.8-66.54,11.28-70.08c-3.98-6.03-16.68-26.85-14.16-55.68c2.63-30.03,20.02-48.77,24.96-53.76c-1.07-6.05-5.88-36.95,14.4-66.24c18.88-27.27,46.59-34.48,53.16-36c-2.04-4.08-19.24-30.94-3.24-55.2c21.53-32.64,90.24-75.32,142.08-73.92c17.06,0.46,29.9,9.62,38.58,15.47c9.45-6.25,24.45-14.11,43.98-16.43c52.01-6.18,125.5,57.06,135.13,81.6c6.53,16.63-5.65,30.26-6.4,38.4c6.14,2.1,48.85,14.44,65.19,52.8c10.77,25.29,7.21,48.28,5.28,57.36c3.43,2.98,31.42,28.09,28.67,66.5c-1.75,24.44-14.99,40.87-20.03,46.54c2.74,5.06,18.32,34.98,6.24,69.6c-8.21,23.53-24.8,36.59-31.44,41.28c1.08,6.27,5.17,34.29-12.72,61.44c-15.81,23.99-38.8,32.17-45.6,34.32c-17,30.52-49.92,48.88-84.8,47.31c-34.78-1.57-69.16-22.71-83.4-54.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,386.4c-7.56,1.17-22.5,2.44-39.87-3.32c-18.77-6.22-30.52-17.38-35.76-23.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.48,148.36c3.53-0.17,41.83-1.36,64.92,29.28c15.56,20.65,14.85,43.32,14.4,49.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.35,70.11c31.84-9.96,62.09-2.79,74.89,16.33c2.73,4.07,6.84,11.94,6.92,24.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.88,109.75c0.38-4.07,2.5-21.88,17.68-34.83c21.41-18.26,48.93-9.94,50.68-9.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.72,223.72c0.6-8.98,3.28-29.13,18.24-47.04c30.28-36.27,81.39-28.04,84.01-27.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.72,386.87c7.39,1.02,23,2.17,40.76-4.75c15.39-5.99,25.29-15.28,30.24-20.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.54,195.67c3.6-0.87,17.93-3.88,33.06,4.05c14.04,7.35,19.83,19.44,21.4,23.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.32,447.4c7.74,2,25.88,7.8,41.71,24.55c13.74,14.53,18.94,30.12,20.97,37.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.26,516.32c2.7-7.52,10.14-25.05,28.28-39.28c15.73-12.35,31.73-16.1,39.61-17.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.64,194.39c0.42-3.68,2.51-18.17,15.15-29.66c11.72-10.66,25.06-11.96,28.98-12.19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.d7708454352a773d87ce375ec0c9e054.svg";
export { ForwardRef as ReactComponent };